'use strict';

var React = require('react');

var SvgLogoXIcon = function SvgLogoXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.906 17h4l-5.302-7.814 5.302-6.186h-1.414l-4.523 5.252-3.563-5.252h-4.156l5.444 7.894-5.258 6.106h1.47l4.433-5.172 3.567 5.172Zm-7.275-12.75 7.931 11.5h.985l-7.803-11.5h-1.113Z"
  }));
};
SvgLogoXIcon.displayName = "LogoXIcon";

exports.SvgLogoXIcon = SvgLogoXIcon;
